/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssigneeCandidateDto
 */
export interface AssigneeCandidateDto {
    /**
     * 
     * @type {string}
     * @memberof AssigneeCandidateDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssigneeCandidateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssigneeCandidateDto
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssigneeCandidateDto
     */
    isGlobal: boolean;
}

/**
 * Check if a given object implements the AssigneeCandidateDto interface.
 */
export function instanceOfAssigneeCandidateDto(value: object): value is AssigneeCandidateDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('isGlobal' in value) || value['isGlobal'] === undefined) return false;
    return true;
}

export function AssigneeCandidateDtoFromJSON(json: any): AssigneeCandidateDto {
    return AssigneeCandidateDtoFromJSONTyped(json, false);
}

export function AssigneeCandidateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssigneeCandidateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'isGlobal': json['isGlobal'],
    };
}

export function AssigneeCandidateDtoToJSON(json: any): AssigneeCandidateDto {
    return AssigneeCandidateDtoToJSONTyped(json, false);
}

export function AssigneeCandidateDtoToJSONTyped(value?: AssigneeCandidateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'isGlobal': value['isGlobal'],
    };
}

